import { render, staticRenderFns } from "./select-sex.vue?vue&type=template&id=edb902b8&scoped=true"
import script from "./select-sex.vue?vue&type=script&lang=js"
export * from "./select-sex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb902b8",
  null
  
)

export default component.exports